/**
 * 动态加载高德地图 API
 * @returns {Promise} 返回 Promise，加载成功后 resolve
 */
export function loadAmapScript() {
  // 如果已经加载，直接返回
  if (typeof window.AMap !== 'undefined') {
    return Promise.resolve(window.AMap)
  }

  // 如果正在加载，返回现有的 Promise
  if (window.__amapLoadingPromise) {
    return window.__amapLoadingPromise
  }

  // 创建新的加载 Promise
  window.__amapLoadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=113933dd80cbcb9f3372a68114f6fd9a&plugin=AMap.Geocoder'
    
    script.onload = () => {
      // 等待 AMap 对象可用
      const checkAmap = () => {
        if (typeof window.AMap !== 'undefined') {
          resolve(window.AMap)
        } else {
          setTimeout(checkAmap, 50)
        }
      }
      checkAmap()
    }
    
    script.onerror = () => {
      window.__amapLoadingPromise = null
      reject(new Error('高德地图 API 加载失败'))
    }
    
    document.head.appendChild(script)
  })

  return window.__amapLoadingPromise
}

